import React, { useState, useEffect } from 'react'
import { Panel, Row, Col } from 'rsuite'

import notification from '../../utils/notification'
import IncomeRecordFileTable from '../incomeRecordWidget/IncomeRecordFileTable'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { startLoading, doneLoading } from '../../utils/loading'
import { getBorrowAdvanceAttachments } from '../../redux/actions/paymentRecordAdvance'
import { getValueFromOptions, getDateThaiShort } from '../../utils/dataUtil'

export default function PaymentRecordAdvanceView({ schema: _schema, register, ...props }) {
  const [formSchema, setFormSchema] = useState(_schema)
  const [fileTableData, setFileTableData] = useState([])

  useEffect(() => {
    register('deleteFileIds', [])
    setFileTableData(formSchema?.attachFiles?.values)
  }, [formSchema])

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await getBorrowAdvanceAttachments(fileObj.id)
      var fileName = fileObj.label

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      var file = await getBorrowAdvanceAttachments(fileObj.id)
      var fileName = fileObj.label

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handleDeleteFileTable = (rowData) => {
    let arr = getValues('deleteFileIds') || []
    arr.push(rowData.id)
    setValue('deleteFileIds', arr)

    let _fileTable = fileTableData?.filter((item) => item.id != rowData.id)
    setFileTableData(_fileTable)
  }

  return (
    <>
      <Panel
        bordered
        style={{
          marginTop: 25,
          border: '1px solid #4e4b488c',
        }}
      >
        <Row style={{ marginTop: 30 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.voucherNumber.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{` : ${formSchema.voucherNumber.value || ''}`}</p>
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.accountChannel.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {formSchema.accountChannel.value == 2 ? (
              <>
                <p>
                  {` : ${getValueFromOptions(
                    formSchema.accountChannel.options,
                    formSchema.accountChannel.value || '0'
                  )} ${formSchema.bankAccount.label} : ${getValueFromOptions(
                    formSchema.bankAccount.options,
                    formSchema.bankAccount.value
                  )}`}
                </p>
              </>
            ) : (
              <>
                <p>
                  {` : ${getValueFromOptions(
                    formSchema.accountChannel.options,
                    formSchema.accountChannel.value || '0'
                  )}`}
                </p>
              </>
            )}
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.referenceNumber.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{` : ${formSchema.referenceNumber.value || ''}`}</p>
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.receiveMoneyEtc.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{` : ${formSchema.receiveMoneyEtc.value || ''}`}</p>
          </Col>

          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.voucherDate.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{` : ${getDateThaiShort(formSchema.voucherDate.value)}`}</p>
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.startDateActive.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{` : ${getDateThaiShort(formSchema.startDateActive.value)}`}</p>
          </Col>

          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.stopDateActive.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{` : ${getDateThaiShort(formSchema.stopDateActive.value)}`}</p>
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.borrowedDate.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{` : ${getDateThaiShort(formSchema.borrowedDate.value)}`}</p>
          </Col>

          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.dueDate.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{` : ${getDateThaiShort(formSchema.dueDate.value)}`}</p>
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.description.label}
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            <p>{` : ${formSchema.description.value || ''}`}</p>
          </Col>
        </Row>

        {/* ยกเลิกการขอยืมเงิน */}
        {formSchema.borrowStatus == 3 && (
          <Row style={{ marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              {formSchema.cancelReason.label}
            </Col>
            <Col lg={20} md={20} sm={24} xs={24}>
              <p>{` : ${formSchema.cancelReason.value || ''}`}</p>
            </Col>
          </Row>
        )}

        {/* การโอนเงินคืน */}
        {formSchema.borrowStatus == 3 && (
          <Row style={{ marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              {formSchema.cancelType.label}
            </Col>
            <Col lg={20} md={20} sm={24} xs={24}>
              <p>{` : ${getValueFromOptions(formSchema.cancelType.options, formSchema.cancelType.value) || ''}`}</p>
            </Col>
          </Row>
        )}

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.attachFiles.label}
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            {fileTableData?.length > 0 && (
              <>
                <IncomeRecordFileTable
                  data={fileTableData}
                  deleteable={false}
                  onPreview={onPreview}
                  onDownload={onDownload}
                  onDelete={(rowData) => handleDeleteFileTable(rowData)}
                />
              </>
            )}
          </Col>
        </Row>
      </Panel>
    </>
  )
}
